import type { ReactNode } from "react";
import "./GlowingShadow.css";
import { cx } from "./ui";

/**
 * Decorative rotating glow ring, meant to wrap a single call-to-action
 * (e.g. a primary submit button). Purely visual — the child element stays
 * the real interactive control, so focus/keyboard behavior is unaffected.
 */
export function GlowingShadow({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={cx("glow-container", className)}>
      <span className="glow" aria-hidden="true" />
      <div className="glow-content">{children}</div>
    </div>
  );
}
